import { http } from './config'

export default {

  getAllLoads: () => {
    return http.get('loads')
  },

  palletizeLoad: (loadID) => {
    return http.post('palletize_load/?load_id=' + loadID)
  },

  resetPalletization: (loadID) => {
    return http.post('reset_palletization/?load_id=' + loadID)
  },

  repalletize_or_reorder_load: (loadID, sort_type = '', palletization_type = '') => {
    return http.post('repalletize_or_reorder_load/?load_id=' + loadID + '&sort_type=' + sort_type + '&palletization_type=' + palletization_type)
  },

  palletizeSelectedLoads (loadIDs) {
    return http.post('palletize_selected_loads/', { load_ids: loadIDs })
  },

  exportPalletizedProducts: (loadID, localityId) => {
    return http.get('loads/' + loadID + '/export_palletized_products/?locality_id=' + localityId)
  },

  exportAllPalletizedProducts: (delivery_date, localityId) => {
    return http.get('loads/export_all_palletized_products/?delivery_date=' + delivery_date + '&locality_id=' + localityId)
  },

  palletizeAllLoads: (params) => {
    return http.post('palletize_all_loads/?delivery_date=' + params.delivery_date + '&locality_id=' + params.locality_id)
  },
}
